/**
 * Discord-style per-channel decoration catalog — chosen in the Theme Studio and
 * rendered by `@/components/ChannelFx` both there and in the live community rail.
 * Each effect is an emoji + a Tailwind animation class (defined in tailwind.config).
 */
export type ChannelEffect = 'none' | 'flames' | 'sparkles' | 'stars' | 'hearts' | 'bolt' | 'party';

export const CHANNEL_EFFECTS: { id: ChannelEffect; label: string; emoji: string; anim: string }[] = [
  { id: 'none', label: 'None', emoji: '', anim: '' },
  { id: 'flames', label: 'Flames', emoji: '🔥', anim: 'animate-flame-flicker' },
  { id: 'sparkles', label: 'Sparkles', emoji: '✨', anim: 'animate-twinkle' },
  { id: 'stars', label: 'Stars', emoji: '⭐', anim: 'animate-twinkle' },
  { id: 'hearts', label: 'Hearts', emoji: '💜', anim: 'animate-float-up' },
  { id: 'bolt', label: 'Bolt', emoji: '⚡', anim: 'animate-flame-flicker' },
  { id: 'party', label: 'Party', emoji: '🎉', anim: 'animate-twinkle' },
];

export const FX_BY_ID: Record<string, { id: ChannelEffect; label: string; emoji: string; anim: string }> =
  Object.fromEntries(CHANNEL_EFFECTS.map((e) => [e.id, e]));
